import { Col, List, Row, Typography } from "antd";
import moment from "moment";
import { useState } from "react";
import { dateFormat } from "../../../../../../shared/utils/Dates/format";
import color from "../../../../../../theme/color";
import { CustomDrawer } from "../../../../Drawer";
import { ArrowSmallLeft, GhostClose } from "../../../../Icon";
import { IconForm } from "../../../../Icon/index.styled";

export interface RepairCsMemoHistoryDrawerProps {
  visible?: boolean;
  dataSource?: any;
  onClose?: () => void;
}

/**
 * 매장 - 예약정보 메모 히스토리
 * @param param0
 * @returns
 */
export const RepairCsMemoHistoryDrawer: React.FC<
  RepairCsMemoHistoryDrawerProps
> = ({ visible = false, dataSource = [], onClose = () => void 0 }) => {
  const [ellipsis, setEllipsis] = useState<number | undefined>();

  return (
    <>
      <CustomDrawer
        title={`메모 히스토리 (${dataSource?.length})`}
        open={visible}
        onClose={onClose}
        closable={false}
        getContainer="#cgInfoRoot"
        push={false}
        extra={
          <IconForm
            component={GhostClose}
            style={{ fontSize: 16 }}
            onClick={onClose}
          />
        }
        destroyOnClose
        bodyStyle={{ padding: 0 }}
      >
        <List
          dataSource={dataSource}
          split
          style={{ width: "100%" }}
          renderItem={(item: any, idx) => (
            <List.Item
              style={{
                padding: 20,
              }}
              onClick={() => {
                setEllipsis((prev) => (prev !== idx ? idx : undefined));
              }}
            >
              <Row gutter={[0, 8]} style={{ width: "100%" }}>
                <Col span={24}>
                  <Row
                    wrap={false}
                    gutter={8}
                    align="top"
                    style={{ width: "100%" }}
                  >
                    <Col flex="auto">
                      <Typography.Paragraph
                        style={{
                          color: color.gray2,
                          margin: 0,
                          fontSize: 17,
                          fontWeight: 400,
                          lineHeight: "24px",
                          whiteSpace: ellipsis === idx ? "pre-wrap" : undefined,
                        }}
                        ellipsis={
                          ellipsis !== idx
                            ? {
                                expandable: false,
                                rows: 1,
                              }
                            : false
                        }
                      >
                        {item?.orderMemo || "-"}
                      </Typography.Paragraph>
                    </Col>
                    <Col flex="none">
                      <IconForm
                        component={ArrowSmallLeft}
                        style={{ fontSize: 12 }}
                        rotate={ellipsis !== idx ? 270 : 90}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Typography.Text style={{ color: color.gray4, fontSize: 13 }}>
                    {dateFormat(moment(item?.createdAt), "YYYY.MM.DD HH:mm")}
                  </Typography.Text>
                </Col>
              </Row>
            </List.Item>
          )}
        />
      </CustomDrawer>
    </>
  );
};
